import React, {Fragment} from 'react'
import {Link} from 'react-router-dom'

const ThemeBannerOne = () => {
    return (
        <Fragment>
            <div className="theme-banner-one pt-205 pb-35 pt-lg-120 pt-md-80 pt-xs-60">
                <div className="shadow-text">CODAM</div>
                {/* 대형 line-1 SVG·회전 도형만 클립 (% 기준은 shadow-text 가 기존과 같게 유지) */}
                <div className="theme-banner-one__bg" aria-hidden="true">
                    <div className="theme-banner-one__wave-layer">
                        <img className="banner-shape shape-one" src="assets/img/shape/line-1.svg" alt="" />
                    </div>
                    <div className="theme-banner-one__motion-shapes">
                        <img className="banner-shape shape-two d-none d-lg-inline-block" src="assets/img/shape/star-1.svg" alt="" />
                        <img className="banner-shape shape-four" src="assets/img/shape/line-round-1.svg" alt="" />
                        <img className="banner-shape shape-three d-none d-lg-inline-block" src="assets/img/shape/star-2.svg" alt="" />
                    </div>
                </div>
                <div className="container">
                    <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                        <div className="col-11">
                            <div className="theme__content text-center">
                                <div className="hero-copy-stack">
                                    <h1 className="main-title-one">
                                        <span>비즈니스 성장을</span>
                                        <span>연결하는 프리미엄</span>
                                        <span>IT 솔루션 파트너</span>
                                    </h1>
                                    <p className="hero-sub-desc">CODAM은 웹 플랫폼 구축, AI 기반 시스템 개발, 데이터 인프라, 클라우드 아키텍처, 사이버 보안까지 기업의 디지털 경쟁력을 완성합니다.</p>
                                </div>
                                <div className="hero-btn-group">
                                    <Link className="theme_btn" to="/contact">프로젝트 문의하기</Link>
                                    <Link className="theme_btn theme_btn--outline ms-3" to="/project-grid">구축 사례 보기</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ThemeBannerOne
